<template>
  <v-card class="common-card pb-0 mb-0">
    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
      <div class="text-center">
        <v-icon class="green--text me-2" style="font-size: 30px"
          >mdi-check-decagram</v-icon
        >
        <span class="font-weight-bold fs-large"
          >خرید شما با موفقیت انجام شد.</span
        >
      </div>
    </v-col>
    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
      <div class="text-center my-3 d-flex flex-column">
        <!-- <p>Invoice Number: {{ invoiceNumber }}</p> -->
        <span class="font-weight-bold fs-medium"
          >کد خرید شما : {{ invoiceCode }}</span
        >
        <span
          >برای مشاهده جزییات خرید خود به بخش حساب کاربری رفته و لیست خرید خود
          را بررسی کنید</span
        >
      </div>
    </v-col>
    <v-row>
      <v-col xl="5" lg="4" md="4" sm="12" xs="12" cols="12" class="p-0"></v-col>
      <!-- <v-col xl="2" lg="3" md="3" sm="6" xs="12" cols="12">
        <v-btn
          class="purple-borderedBtn"
          height="48"
          width="100%"
          @click="checkCart()"
        >
          مشاهده جزییات خرید
        </v-btn>
      </v-col> -->
      <v-col xl="2" lg="4" md="4" sm="6" xs="12" cols="12">
        <v-btn class="secondary" height="48" width="100%" @click="goToHome">
          بازگشت به صفحه اصلی
        </v-btn>
        <v-col xl="5" lg="4" md="4" sm="12" xs="12" cols="12" class="p-0"></v-col>
      </v-col>
    </v-row>
    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
      <div class="image_succsecc">
        <img src="../../assets/images/buy.svg" alt="" />
      </div>
    </v-col>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      invoiceCode: "",
      invoiceNumber: "",
    };
  },
  methods: {
    ...mapMutations(["setInCart"]),
    goToHome() {
      this.$router.push("/main");
    },
    checkCart() {
      this.$router.push("/purchaseDetails/" + this.invoiceNumber);
    },
  },
  mounted() {
    if (!localStorage.getItem("shopToken")) {
      this.$router.push("/main");
      this.toast("ابتدا لاگین کنید", "error");
    } else {
      this.invoiceNumber = this.$route.query.invoiceNumber;
      this.invoiceCode = this.$route.query.invoiceCode;
      // this.invoiceCode = localStorage.getItem("invoiceCode");
      // this.invoiceNumber = localStorage.getItem("invoiceNumber");
      localStorage.removeItem("cart");
      localStorage.removeItem("invoiceCode");
      localStorage.removeItem("purchaseIsChanged");
      localStorage.removeItem("isUserAddressCompleted");
      localStorage.removeItem("shippingAddress");
      localStorage.removeItem("shippingCost");
      this.setInCart([]);
    }
  },
};
</script>

<style lang="scss">
.image_succsecc {
  width: 350px;
  margin: auto;
  img {
    width: 100%;
  }
}
</style>
